import merge from 'lodash/merge';
import baseStyles from '../Base/Base.styles';
import {parseResponsiveProperty} from '@converdy/styles';

export default ({
  base,

  width,
  maxWidth,

  textColor,
  textActiveColor,
  pillColor,
  pillActiveColor,
}) => {
  let jss = {
    root: {
      '--text-color': textColor,
      '--text-active-color': textActiveColor,
      '--pill-color': pillColor,
      '--pill-active-color': pillActiveColor,
      ...baseStyles(base),
    },
  };

  if (width === 'custom') {
    merge(
      jss.root['& > .box'],
      parseResponsiveProperty((v) => {
        return v && v.value && v.unit
          ? {
              maxWidth: v.value + v.unit,
            }
          : {};
      }, maxWidth),
    );
  }

  return jss;
};
